<template>
  <div>
    <v-row v-if="notes && notes.length > 0">
      <v-col cols="12" class="pb-0">
        <div v-for="note in notes" :key="note.id" class="coach-note">
          <span class="font-10">{{ niceDate(note.createdAt) }} - {{ coachFullName(note) }}</span
          ><br />
          <span>{{ note.note }}</span>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!create">
      <v-col cols="12" class="text-right">
        <v-btn class="text-right" small @click="createNewNote()">
          Add Note
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="create">
      <v-col cols="12" class="text-right">
        <v-textarea :id="'new_note_' + column" v-model="newNote" rows="2"/>
        <v-spacer></v-spacer>
        <v-btn small @click="saveNote">
          Save
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { YYYYMMDD_readable } from "@/lib/fancy_date";
import { ADD_COACH_MEDICAL_ASSESSMENT_NOTE_MUTATION } from "@/constants/graphql/medical_assessment/medical_assessment";

export default {
  name: "CoachMedicalAssessmentFieldNote",
  props: {
    medicalAssessmentId: {
      type: Number,
      default: null,
    },
    column: {
      type: String,
      default: "",
    },
    notes: {
      type: Array,
      default: null,
    },
  },
  data() { 
    return {
      create: false,
      newNote: "",
    }
  },
  methods: {
    niceDate(date) {
      return YYYYMMDD_readable(date);
    },
    coachFullName(note) {
      return note.coach.firstName + " " + note.coach.lastName;
    },
    createNewNote() {
      this.create = true;

      setTimeout(() => {
        let note = document.getElementById(`new_note_${this.column}`);
        if (note){
          note.focus();
        }
      }, 50)
    },
    saveNote() {
      let input = {
        medicalAssessmentId: this.medicalAssessmentId,
        column: this.column,
        note: this.newNote,
      };

      this.$apollo
        .mutate({
          mutation: ADD_COACH_MEDICAL_ASSESSMENT_NOTE_MUTATION,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (response.data.addCoachMedicalAssessmentNote.success) {
            this.$toasted.success("Note added", {
              icon: "arm-flex",
              duration: 2000,
              position: "bottom-center",
            });
            this.$emit("update-the-notes-please");
            this.create = false;
            this.newNote = "";
          } else {
            this.$toasted.error("Unable to create note", {
              duration: 2000,
              position: "bottom-center",
            });
          }
        })
        .catch((error) => {
          this.$emit("problem");
          this.problemConnecting = true;
        });
    },
  },
};
</script>

<style scoped>
.coach-note:not(:last-child) {
  margin-bottom: 10px;
}

.font-10 {
  font-size: 10px;
}
</style>
